import type { TextNumber } from "@vaulted/shared";
import { formatPhone } from "@vaulted/shared";
import { useQuery } from "@tanstack/react-query";
import { get } from "../api";
import { SelectField } from "./ui";

/** The client's numbers a text can go to (mobile first, then linked numbers such as a parent's). */
export const useTextNumbers = (clientId: string) => useQuery({ queryKey: ["text-numbers", clientId], queryFn: () => get<TextNumber[]>(`/api/clients/${clientId}/text-numbers`) });

/** "To": which of the client's numbers a text goes to; "" is their mobile. Hidden when there's only one. */
export function TextNumberSelect({ numbers, value, onChange }: { numbers: TextNumber[] | undefined; value: string; onChange: (phone: string) => void }) {
  if (!numbers || numbers.length < 2) return null;
  return (
    <SelectField label="To" value={value} onChange={(e) => onChange(e.target.value)}>
      {numbers.map((n) => (
        <option key={n.phone} value={n.mobile ? "" : n.phone}>
          {formatPhone(n.phone)} {n.mobile ? "(mobile)" : n.label ? `(${n.label})` : "(other number)"}
        </option>
      ))}
    </SelectField>
  );
}

